import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, getUserRoute } = useAuth();

  const handleGoHome = () => {
    if (isAuthenticated) {
      const userRoute = getUserRoute();
      navigate(userRoute);
    } else {
      navigate("/");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center px-6 py-8">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300 select-none">404</h1>
        </div>

        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            ¡Página no encontrada!
          </h2>
          <p className="text-lg text-gray-600 mb-2">
            La página que buscas no existe o ha sido movida.
          </p>
          <p className="text-sm text-gray-500">
            Verifica la URL o regresa a una página válida.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* <button
            onClick={handleGoHome}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition duration-300 shadow-sm hover:shadow-md"
          >
            {isAuthenticated ? "Ir al Dashboard" : "Ir al Login"}
          </button> */}

          <button
            onClick={handleGoBack}
            className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition duration-300 shadow-sm hover:shadow-md"
          >
            Regresar
          </button>
        </div>

        {/* {isAuthenticated && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-4">Páginas disponibles:</p>
            <div className="flex flex-wrap gap-2 justify-center">
              <button
                onClick={() => navigate("/home")}
                className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded transition"
              >
                Inicio
              </button>
              <button
                onClick={() => navigate("/despachos")}
                className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded transition"
              >
                Nueva Solicitud
              </button>
              <button
                onClick={() => navigate("/created-requests")}
                className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded transition"
              >
                Solicitudes
              </button>
            </div>
          </div>
        )} */}

        <div className="mt-8 text-xs text-gray-400">
          <p>Si el problema persiste, contacta al administrador del sistema.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
